import { omit } from 'lodash';

import { normalizeJsonObject, mapColumnIdsAndNormalizedColumnIds } from '@backoffice/utils';
import bufferStockXlsConstants from '@commons/Excels/constants/bufferStock.xlsx.constant';
import entityXlsConstants from '@commons/Excels/constants/entity.xlsx.constant';
import nonSalesConsumptionXlsConstants from '@commons/Excels/constants/nonSalesConsumption.xlsx.constant';

export const formatEntityBatchUpdateFile = (fileIngredientsData) => {
  const entitySheetConfig = entityXlsConstants.getSheetConfig();
  const bufferStockSheetConfig = bufferStockXlsConstants.getBufferStockSheetConfig();
  const nonSalesConsumptionSheetConfig =
    nonSalesConsumptionXlsConstants.getNonSalesConsumptionSheetConfig();

  const formattedData = normalizeJsonObject(fileIngredientsData);

  return Object.keys(formattedData).reduce((result, sheetName) => {
    if (sheetName === entitySheetConfig.SHEET.name) {
      result.ingredients = formattedData[sheetName].map((current) =>
        mapColumnIdsAndNormalizedColumnIds(current, entityXlsConstants.getNormalizedColumnIds()),
      );
    }

    if (sheetName === bufferStockSheetConfig.SHEET.name) {
      result[bufferStockSheetConfig.SHEET.id] = formattedData[sheetName].map((current) => ({
        // Spreading to get all the dynamic columns, omitting the normalized name column to avoid duplicates
        ...omit(current, [
          bufferStockSheetConfig.COLUMNS_CONFIG.NAME,
          bufferStockSheetConfig.COLUMNS_CONFIG.INGREDIENT_ID,
        ]),
        ...mapColumnIdsAndNormalizedColumnIds(
          current,
          bufferStockXlsConstants.getNormalizedColumnIds(),
        ),
      }));
    }

    if (sheetName === nonSalesConsumptionSheetConfig.SHEET.name) {
      result[nonSalesConsumptionSheetConfig.SHEET.id] = formattedData[sheetName].map((current) => ({
        // Spreading to get all the dynamic columns, omitting the normalized name and unit columns to avoid duplicates
        ...omit(current, [
          nonSalesConsumptionSheetConfig.COLUMNS_CONFIG.NAME,
          nonSalesConsumptionSheetConfig.COLUMNS_CONFIG.UNIT,
          nonSalesConsumptionSheetConfig.COLUMNS_CONFIG.INGREDIENT_ID,
        ]),
        ...mapColumnIdsAndNormalizedColumnIds(
          current,
          nonSalesConsumptionXlsConstants.getNormalizedColumnIds(),
        ),
      }));
    }

    return result;
  }, {});
};
